import { useEffect, useState } from "react";
import { _Ability, _Competition } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { CompetitionTypeEditor } from "../../CompetitionType/CompetitionType.editor";
import { GenericCompetitionEditor } from "../../GenericCompetition/GenericCompetition.editor";

interface PropCompetition {
    _IDAppointManual: number;
}

export const Competition = ({ _IDAppointManual }: PropCompetition) => {

    const competition = useDataBean(_Competition);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        if (_IDAppointManual >= 0) {
            getLista();
        }
    }, [_IDAppointManual])

    const getLista = () => {

        competition.instance.getCompetitionCatalog(null, _IDAppointManual, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        competition.setBean({
            IDAppointmentManual: _IDAppointManual,
        });
        setModal({ ...modal, "name": "Agregar Competencia Comportamentales del Cargo", "view": true });
    }

    const deleteItem = () => {
        competition.instance.deleteCompetition(competition.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const editaItem = () => {
        competition.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCompetition', visible: true },
        { title: 'Tipo de Competencia', property: 'CompetitionTypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Nivel esperado', property: 'ExpectedPercentLevel', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar Competencia Comportamentales ${competition.bean.Name} del Cargo`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={competition.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-12">
                            <CompetitionTypeEditor idSelector={competition.bean.IDCompetitionType} onChange={(e) => { competition.setBean({ ...competition.bean, "IDCompetitionType": e }) }} />
                        </div>
                        <div className="col-12">
                            <GenericCompetitionEditor IDCompetitionType={competition.bean.IDCompetitionType} idSelector={competition.bean.IDGenericCompetition} onChange={(e) => { competition.setBean({ ...competition.bean, "IDGenericCompetition": e }) }} />
                        </div>
                        <div className="col-12">
                            <label>Nivel % Esperado en el Cargo:</label>
                            <input type="number" name="ExpectedPercentLevel" className="form-control" value={competition.bean.ExpectedPercentLevel} onChange={competition.handleChange} />
                        </div>
                        {/* <div className="col-6">
                            <label >Nombre:</label>
                            <input type="text" name="Name" className="form-control" value={competition.bean.Name} onChange={competition.handleChange} />
                        </div> */}
                        {/* <div className="col-12">
                            <label>Descripción: </label>
                            <textarea name="Description" className="form-control" value={competition.bean.Description} onChange={competition.handleChange} />
                        </div> */}
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {competition.bean.Name}</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}